import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=24060538"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports